import { useEffect, useState } from "react";
import { Kart } from "@koclukpanel/ui";
import { duyuruOkundu, duyurularim, type Duyurum } from "./api";

/**
 * DUYURULAR — F-NTF-08b (Emre 06.10.2026)
 *
 * Öğrenci uygulamasında duyuru okuyan bir ekran YOKTU (ölçüldü 06.10.2026):
 * `GET /operasyon/duyurular` öğrenciye ve veliye açıktı ama hiçbir ekran
 * çağırmıyordu. Koç duyurusu bildirim ("koçundan yeni bir duyuru var")
 * üretiyor; bildirimin götürdüğü yerde duyurunun kendisi olmalı.
 *
 * Kime görüneceği SUNUCUDA (`duyuruGorunurMu`); burada süzme yok.
 * Hata/yükleme sessiz: kart ana ekranın asıl işi değil.
 */

const GOSTERILEN = 5;

function tarih(iso: string): string {
  return new Date(iso).toLocaleDateString("tr-TR", {
    timeZone: "Europe/Istanbul",
    day: "numeric",
    month: "long",
  });
}

/** Sunucu da süzüyor (F-SCH-03b); tıklanabilir adres yine yalnız http/https. */
function guvenliBaglanti(adres: string | null): string | null {
  return adres !== null && /^https?:\/\//i.test(adres) ? adres : null;
}

export function Duyurularim() {
  const [liste, setListe] = useState<Duyurum[]>([]);
  const [isleniyor, setIsleniyor] = useState<string | null>(null);

  useEffect(() => {
    let iptal = false;
    void duyurularim()
      .then((y) => {
        if (!iptal) setListe(y.duyurular.slice(0, GOSTERILEN));
      })
      .catch(() => undefined);
    return () => {
      iptal = true;
    };
  }, []);

  if (liste.length === 0) return null;

  const okudum = async (id: string) => {
    setIsleniyor(id);
    try {
      await duyuruOkundu(id);
      setListe((l) => l.map((d) => (d.id === id ? { ...d, okunduMu: true } : d)));
    } catch {
      // Sessiz — işaret bir sonraki açılışta yeniden denenebilir.
    } finally {
      setIsleniyor(null);
    }
  };

  return (
    <Kart baslik="Duyurular">
      <ul className="flex flex-col gap-4">
        {liste.map((d) => {
          const baglanti = guvenliBaglanti(d.linkUrl);
          return (
            <li key={d.id} className="flex flex-col gap-1">
              <p className="text-notr-900 text-sm font-semibold">
                {!d.okunduMu && (
                  <span className="bg-marka-600 mr-2 inline-block h-2 w-2 rounded-full align-middle">
                    <span className="sr-only">Okunmadı: </span>
                  </span>
                )}
                {d.title}
              </p>
              <p className="text-notr-700 text-sm whitespace-pre-wrap">{d.body}</p>
              <div className="flex flex-wrap items-center gap-3">
                <span className="text-notr-600 text-xs">{tarih(d.publishAt)}</span>
                {baglanti && (
                  <a
                    href={baglanti}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-marka-700 inline-flex min-h-11 items-center text-sm underline"
                  >
                    Ayrıntı
                  </a>
                )}
                {!d.okunduMu && (
                  <button
                    type="button"
                    disabled={isleniyor === d.id}
                    onClick={() => void okudum(d.id)}
                    className="text-marka-700 inline-flex min-h-11 items-center text-sm font-medium"
                  >
                    Okudum
                  </button>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </Kart>
  );
}
